import React, {useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet, Platform, Modal} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {useAuth} from '../contexts/AuthContext';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {faCog, faDoorOpen, faUser, faUserCircle} from '@fortawesome/free-solid-svg-icons';
import {Fonts} from '../config/fonts';

interface AppHeaderProps {
  title?: string;
}

const AppHeader: React.FC<AppHeaderProps> = ({title}) => {
  const navigation = useNavigation();
  const {signOut, user} = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  const handleSettings = () => {
    setShowMenu(false);
    navigation.navigate('Settings' as never);
  };

  const handleProfile = () => {
    setShowMenu(false);
    // Pour l'instant, rediriger vers Settings (Profil sera dans Settings)
    navigation.navigate('Settings' as never);
  };

  const handleSignOut = () => {
    setShowMenu(false);
    signOut();
  };

  return (
    <>
      <View style={styles.header}>
        <View style={styles.headerContent}>
          <Text style={styles.logoText}>L'AVENTURIER</Text>
        </View>
        <TouchableOpacity
          style={styles.settingsButton}
          onPress={() => setShowMenu(true)}>
          <FontAwesomeIcon icon={faCog} size={18} color="rgba(232, 230, 225, 0.7)" />
        </TouchableOpacity>
      </View>

      {/* Menu contextuel */}
      <Modal
        visible={showMenu}
        transparent
        animationType="fade"
        onRequestClose={() => setShowMenu(false)}>
        <TouchableOpacity
          style={styles.modalOverlay}
          activeOpacity={1}
          onPress={() => setShowMenu(false)}>
          <View style={styles.menuDropdown}>
            {/* Profil */}
            <TouchableOpacity
              style={styles.menuItem}
              onPress={handleProfile}>
              <FontAwesomeIcon icon={faUserCircle} size={18} color="#2C2C2C" />
              <Text style={styles.menuItemText}>Profil</Text>
            </TouchableOpacity>

            {/* Paramètres */}
            <TouchableOpacity
              style={styles.menuItem}
              onPress={handleSettings}>
              <FontAwesomeIcon icon={faCog} size={18} color="#2C2C2C" />
              <Text style={styles.menuItemText}>Paramètres</Text>
            </TouchableOpacity>

            <View style={styles.menuDivider} />

            {/* Se déconnecter */}
            <TouchableOpacity
              style={styles.menuItem}
              onPress={handleSignOut}>
              <FontAwesomeIcon icon={faDoorOpen} size={18} color="#D32F2F" />
              <Text style={[styles.menuItemText, styles.menuItemDanger]}>Se déconnecter</Text>
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  header: {
    backgroundColor: '#2C2C2C', // Charbon au lieu de noir pur
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 8, // Hauteur réduite (8 au lieu de 12)
    ...Platform.select({
      web: {
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
      },
      default: {
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 1},
        shadowOpacity: 0.15,
        shadowRadius: 2,
        elevation: 2,
      },
    }),
  },
  menuButton: {
    padding: 8,
    marginRight: 8,
  },
  headerContent: {
    flex: 1,
    alignItems: 'center',
  },
  logoText: {
    fontSize: 16, // Un peu plus petit
    fontFamily: Fonts.title,
    fontWeight: '600',
    color: '#E8E6E1',
    letterSpacing: 1,
  },
  settingsButton: {
    padding: 8,
    marginLeft: 8,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    paddingTop: Platform.OS === 'web' ? 56 : 56,
    paddingRight: 16,
  },
  menuDropdown: {
    // Style "papier" avec coins légèrement irréguliers
    backgroundColor: '#F5F3ED',
    ...Platform.select({
      web: {
        borderTopLeftRadius: 10,
        borderTopRightRadius: 12,
        borderBottomRightRadius: 12,
        borderBottomLeftRadius: 8,
      },
      default: {
        borderRadius: 12,
      },
    }),
    paddingVertical: 8,
    minWidth: 200,
    borderWidth: 1,
    borderColor: '#D4C4B0',
    ...Platform.select({
      web: {
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)',
      },
      default: {
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.15,
        shadowRadius: 6,
        elevation: 4,
      },
    }),
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 18,
    paddingVertical: 14,
  },
  menuItemText: {
    fontSize: 15,
    color: '#2C3E50',
    marginLeft: 14,
    fontWeight: '500',
  },
  menuItemDanger: {
    color: '#D32F2F',
  },
  menuDivider: {
    height: 1,
    backgroundColor: '#D4C4B0',
    marginVertical: 4,
    opacity: 0.5,
  },
});

export default AppHeader;
